import { useEffect, useRef, useState } from 'react';
import * as Observables from '../rxjs-stores';
import connect from "../socketio.service";

export const useDate = () => {
	const [date, setDate] = useState(new Date());

	useEffect(() => {
		const num = setInterval(() => setDate(() => new Date()), 1000);
		return () => clearInterval(num);
	}, []);
	return { date };
};

export const useLiveGames = () => {
	const [liveGames, setLiveGames] = useState([]);

	useEffect(() => {
		const sub = Observables.liveGames$.subscribe({
			next: (data) => {
				setLiveGames(() => data);
			}
		});
		return () => sub.unsubscribe();
	}, []);

	return {
		liveGames,
		totalGames: liveGames.length
	};
};

/**
 * Just use but do not page the devil
 */
export const usePage = (delayInMilliseconds, pageSize, totalGames) => {
	const totalGamesRef = useRef(totalGames);
	totalGamesRef.current = totalGames;
	const pageCount = () => Math.max(1, Math.ceil(totalGames / pageSize));
	const [state, setState] = useState({ page: 1, totalPages: pageCount() });

	useEffect(() => {
		setState(prev => {
			const totalPages = pageCount();
			return { page: Math.min(prev.page, totalPages), totalPages };
		});
	}, [pageSize, totalGames]);

	useEffect(() => {
		const num = setInterval(() => {
			setState(prev => {
				const totalPages = Math.max(1, Math.ceil(totalGamesRef.current / pageSize));
				return { page: prev.page + 1 > totalPages ? 1 : prev.page + 1, totalPages };
			});
		}, delayInMilliseconds);
		return () => clearInterval(num);
	}, [delayInMilliseconds, pageSize]);

	const setPage = (page) => {
		setState(prev => {
			const totalPages = pageCount();
			return { page: Math.min(Math.max(1, Number(page) || 1), totalPages), totalPages };
		});
	};

	return { ...state, setPage };
};

export const useSocketIO = () => {
	const [connected, setConnected] = useState(false);
	useEffect(() => {
		connect().on('connect', function () {
			setConnected(() => true);
		});
	}, []);
	return { connected };
};
